export interface Vehicle {
  slug: string
  name: string
  vin: string
  year: string
  initialReg: string
  initialRegCs: string
  model: string
  body: string
  bodyCs?: string
  mileage: string
  power: string
  transmission: string
  transmissionCs: string
  drive?: string
  driveCs?: string
  price: string
  cardPower: string
  images: string[]
  hasPhotos: boolean
  // Extended specs (optional)
  engineType?: string
  engineTypeCs?: string
  displacement?: string
  torque?: string
  acceleration?: string
  topSpeed?: string
  weight?: string
  wheels?: string
  wheelsCs?: string
  brakes?: string
  brakesCs?: string
}

export const vehicles: Vehicle[] = [
  {
    slug: '911-gts',
    name: 'Porsche 911 Carrera GTS (992)',
    vin: 'WP0ZZZ995PS213642',
    year: '2023',
    initialReg: 'May 2023',
    initialRegCs: 'Květen 2023',
    model: '992 GTS',
    body: 'Coupé',
    mileage: '17 500 km',
    power: '353 kW / 480 bhp',
    transmission: '8 gears PDK',
    transmissionCs: '8 stupňů PDK',
    price: '€ 175 800',
    cardPower: '353 kW',
    images: [
      'https://cdn.magicpatterns.com/uploads/vn9rRc6M6MNZxeCHNrDR1A/IMG_9098.jpg',
      'https://cdn.magicpatterns.com/uploads/1DWGgAjLTXBtJLJBTJgXHh/IMG_2223.jpg',
      'https://cdn.magicpatterns.com/uploads/e9xArV6VBM2K6J5JC1WUia/IMG_9116.jpg',
      'https://cdn.magicpatterns.com/uploads/irWF5tL5ZpPrPKpEA24GRq/IMG_9183.jpg',
      'https://cdn.magicpatterns.com/uploads/rVRipSuNShWJqyBcp1aJ8G/IMG_2256.jpg',
      'https://cdn.magicpatterns.com/uploads/a2Er962Bd6ayH6cd4fhJnD/DJI_0607.jpg',
      'https://cdn.magicpatterns.com/uploads/5KRV9K8eC6y9SGxQrJRF2A/IMG_2192.jpg',
      'https://cdn.magicpatterns.com/uploads/2yujna2jiQsrbAeTkhNuae/IMG_2246.jpg',
      'https://cdn.magicpatterns.com/uploads/9uWpYKh29iXgEHminuYiRw/IMG_2225.jpg',
      'https://cdn.magicpatterns.com/uploads/7crqy8yTJ9gXnN4zgb71TX/IMG_2229.jpg',
    ],
    hasPhotos: true,
  },
  {
    slug: '718-spyder-rs',
    name: 'Porsche Boxster 718 Spyder RS Weissach',
    vin: 'WPOZZZ981RK233350',
    year: '2025',
    initialReg: 'August 2025',
    initialRegCs: 'Srpen 2025',
    model: '718 Spyder RS Weissach',
    body: 'Spyder',
    mileage: '16 km',
    power: '368 kW / 500 PS',
    transmission: '7-speed PDK (short-ratio)',
    transmissionCs: '7stupňová PDK (zkrácené převody)',
    drive: 'RWD',
    driveCs: 'Zadní pohon',
    price: '€ 198 400',
    cardPower: '368 kW',
    // Extended specs
    engineType: 'Naturally aspirated flat-6 (Boxer)',
    engineTypeCs: 'Atmosférický plochý šestiválec (Boxer)',
    displacement: '3 996 cm³',
    torque: '450 Nm @ 6 750 rpm',
    acceleration: '0–100 km/h: 3,4 s',
    topSpeed: '308 km/h',
    weight: '1 410 kg',
    wheels: '20" forged alloy, center-lock',
    wheelsCs: '20" kovaná hliníková kola, centrální matice',
    brakes: '6-piston front / 4-piston rear, drilled discs',
    brakesCs: '6pístové vpředu / 4pístové vzadu, vrtané kotouče',
    images: [
      'https://cdn.magicpatterns.com/uploads/xpGg53QTKjTy7qL6tSTKgz/4c7a98ba-5686-4725-a13c-12335ad0767f_(1)_-_kopie.jpg',
      'https://cdn.magicpatterns.com/uploads/go9QFEAV4dpXuW4eQchqeA/2fa257d2-8d03-41c5-a358-fa5dc25b3f7b.jpg',
      'https://cdn.magicpatterns.com/uploads/wy9sTmvkQd2KXBe6u8VUSp/eaa20203-2b5d-47cf-8f92-b892ed2d55fa_-_kopie.jpg',
      'https://cdn.magicpatterns.com/uploads/uzsD9MCjWRCyAN22WWaiH6/d20cf9f6-e817-4a41-b65f-8cf761db73dd.jpg',
      'https://cdn.magicpatterns.com/uploads/u8VSncgqjQKQCGafyb2sVR/9672e058-41ff-4a0a-aba5-de3a6eb1d4c6.jpg',
    ],
    hasPhotos: true,
  },
]

export function getVehicleBySlug(slug: string): Vehicle | undefined {
  return vehicles.find((v) => v.slug === slug)
}
